import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { CoreDialogService } from 'src/app/core/dialogs/core-dialog.service';
import { ViewComponent } from 'src/app/core/view/view.component';
import { TemplatesDetailComponent } from '../templates-detail/templates-detail.component';
import { TemplatesService } from '../templates.service';

@Component({
  selector: 'app-templates-list',
  templateUrl: './templates-list.component.html',
  styleUrls: ['./templates-list.component.scss']
})
export class TemplatesListComponent implements OnInit {
  @ViewChild("view") public view: ViewComponent;
  public templatesFilters : any = {};
  public template_type_id: number = null; 

  constructor(
    private templatesService: TemplatesService,
    private coreDialogService: CoreDialogService,
    private messageService: MessageService,
    private dialogService: DialogService
  ) { }

  ngOnInit(): void {
  }
  search(){
    this.view.fireEvent("templates.list.results","reload");
  }
  delete(template){
    this.coreDialogService.confirm({
      message: '¿Quieres borrar la plantilla ' + template.name + '?',
      header: 'Confirmación de borrado',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.templatesService.delete(template.id).subscribe(
          data => {
            this.messageService.add({ closable: false, severity: "success", detail: 'Eliminada correctamente.' });
            this.view.fireEvent("templates.list.results", "reload");
          },
          error => {
            this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
          }
        );
      },
      reject: () => {
        
      }
    });
  }
  edit(template){
    const ref = this.dialogService.open(TemplatesDetailComponent, {
      data: {
        id: template!=null?template.id:null,
        template_type_id: this.template_type_id
      },
      header: template!=null?'Modificar plantilla':'Añadir plantilla',
      width: '70%'
    });
    ref.onClose.subscribe((data:any) => {
      this.view.fireEvent("templates.list.results","reload");
    });
  }
  onEvent(event: any) {
    if (event.component == "templates.list.filters") {
      if(event.event == "onChange"){
        this.template_type_id = event.data.template_type_id;
        this.templatesFilters = Object.assign(this.templatesFilters, {entity_id: event.data.entity_id});
      }
      if (event.event == "action" && event.action.name == "search") this.view.fireEvent("templates.list.results", "reload");
    }else if(event.component=="templates.list.results"){
      if(event.event=="dblclick") this.edit(event.data);
      if(event.event=="action" && event.action.name=="add") this.edit(null);
      if(event.event=="action" && event.action.name=="edit") this.edit(event.data);
      if(event.event=="action" && event.action.name=="delete") this.delete(event.data);
    }
  }
}
